export default "__VITE_ASSET__f7e6884d__"